// 숫자에 ',' 추가
export const numberFormat = {
    methods: {
        numberFormat(num){
            return new Intl.NumberFormat().format(num);
        }
    },
}